/**
 * formDeriveEntryTableIds
 *
 * Every tableId one entry SOURCES or TARGETS: the fetch-superset rule, per
 * entry. Consumers: `formDeriveConfigTableIds`, the reconciler's
 * unaddressable-table filter and the row trigger's early exit. The trigger and
 * the reconciler MUST answer this question the same way — a narrower trigger
 * spelling exits on a table the reconciler would have read, and the result is
 * silent staleness with no error anywhere. `field` and `referenceProp` sources
 * name no table; a field target names none either.
 */

import { formDeriveEntrySources } from './formDeriveEntrySources';
import type { ArTableId } from '../System.Artifacts.types';
import type { FormDeriveEntry } from '../System.FormDerive.types';

function formDeriveEntryTableIds(entry: FormDeriveEntry): ArTableId[] {
  return [
    ...formDeriveEntrySources(entry).flatMap((source) =>
      source.kind === 'field' || source.kind === 'referenceProp' ? [] : [source.tableId],
    ),
    ...('fieldId' in entry.target ? [] : [entry.target.tableId]),
  ];
}

export { formDeriveEntryTableIds };
